import { render, staticRenderFns } from "./License.Detail.vue?vue&type=template&id=9d939f52&"
import script from "./License.Detail.vue?vue&type=script&lang=js&"
export * from "./License.Detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports